var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hv-carousel" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-wrap justify-content-center" },
      _vm._l(_vm.imageUrlsData, function (imageData, index) {
        return _c(
          "div",
          { key: index, staticStyle: { "max-width": "200px" } },
          [
            _c(
              "a",
              { attrs: { href: imageData.brandLinkCategory } },
              [
                _c("lazy-img", {
                  attrs: {
                    "picture-class": "img-fluid item",
                    "image-url": imageData.customImagePath,
                  },
                }),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }